import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { useGlobalContext } from '../../Context/Authentation'
import { format } from 'timeago.js'

export default function SingleNotes(props) {
    const navigate = useNavigate();
    const { user } = useGlobalContext();
    const id = props.index;
    const wrapper = document.getElementsByClassName("notewrapper");

    // change pin logic index to id of single note
    const PinItemHandler = () => {

        if (wrapper[id].style.order === "1") {

            document.getElementsByClassName("pinItem")[id].classList.add("bi-pin-angle-fill")
            document.getElementsByClassName("pinItem")[id].classList.remove("bi-pin-angle")

            wrapper[id].classList.add("pinned");
            wrapper[id].classList.remove("notpinned");
            wrapper[id].style.order = "0"

            props.PinnedNotes.push(id);
            localStorage.setItem("pinnedNotes", props.PinnedNotes.toString())
            localStorage.setItem("pinned_Note_User", user?._id)


        } else if (wrapper[id].style.order === "0") {

            document.getElementsByClassName("pinItem")[id].classList.remove("bi-pin-angle-fill")
            document.getElementsByClassName("pinItem")[id].classList.add("bi-pin-angle")

            wrapper[id].classList.remove("pinned");
            wrapper[id].classList.add("notpinned");
            wrapper[id].style.order = "1"

            props.PinnedNotes.splice(props.PinnedNotes.indexOf(id), 1);
            localStorage.setItem("pinnedNotes", props.PinnedNotes.toString())
        }

    }

    useEffect(() => {
        localStorage.getItem("pinnedNotes")?.split(",").forEach((e) => {
            if (localStorage.getItem("pinned_Note_User") === user?._id) {
                if (e) {
                    wrapper[e].classList.add("pinned");
                    wrapper[e].classList.remove("notpinned");
                    wrapper[e].style.order = "0"
                    document.getElementsByClassName("pinItem")[e].classList.remove("bi-pin-angle")
                    document.getElementsByClassName("pinItem")[e].classList.add("bi-pin-angle-fill")
                }
            }
        })
        // eslint-disable-next-line 
    }, [])

    const noteMoreclickHandler = () => {
        navigate(`/Home/Note/${props.id}`)
    }

    return (
        <div className='singleNoteContainer' style={{
            border: "1px solid gray", position: "relative"
            , display: "flex", alignItems: "center", justifyContent: "space-around", flexDirection: "column", padding: "10px", borderRadius: "10px", paddingBottom: "25px"
        }}>



            <span style={{ position: "absolute", bottom: "-15px", left: "0px", fontSize: "45px", fontWeight: "700", color: "gray" }}>{props.index + 1}</span>

            <div style={{ position: "absolute", bottom: "5px", right: "10px" }}>

                <p className='text' style={{ fontSize: "15px", opacity: "0.7", margin: "0px", paddingRight: "5px" }}>{format(props?.event?.updatedAt)}</p>

                <i className="bi bi-pencil-square"
                    data-bs-toggle="modal" data-bs-target="#UpdateNotes" style={{ cursor: "pointer", fontSize: "25px", color: "blue" }}
                    onClick={props.UpdateclickHndler}></i>

                &nbsp; &nbsp;

                <i className="bi bi-trash3"
                    data-bs-toggle="modal" data-bs-target="#deleteNotes" style={{ cursor: "pointer", fontSize: "25px", color: "red" }}
                    onClick={props.DeleteclickHndler}></i>

            </div>

            <span id='pinItem' style={{ position: "absolute", top: "-20px", right: "-10px", fontSize: "30px", color: "gray" }} onClick={PinItemHandler}>
                <i className=" pinItem bi bi-pin-angle"></i>
            </span>





            <h4 className='noteHeading text' style={{ margin: "4px" }}>{props.event.title}
            </h4>

            <div className='noteContent text' style={{ overflow: "hidden scroll", width: "100%", height: "fit-content", maxHeight: "150px" }}>{(props.event.content).slice(0, 100)}
                {(props.event.content).length > 100 && <span style={{ color: "blue", fontWeight: "600", cursor: "pointer" }}
                    onClick={noteMoreclickHandler}
                > &nbsp; More...</span>}
            </div>

            <div></div>


        </div>
    )
}
